import {
  nonNullable,
  type DynamicPageRouterData,
} from '@wix/wix-data-client-common-standalone'

export const getAllPageLinkIds = (routers: DynamicPageRouterData[]) =>
  routers
    .flatMap(router =>
      Object.values(router.config.patterns).map(
        pattern => pattern.config.pageLinkId,
      ),
    )
    .filter(nonNullable)
